// This file is auto-generated by @hey-api/openapi-ts

import { bambiApi as coreApi } from '../internal/api.ts';
import {
  type MessagesMessageSettingsRetrieveApiArg,
  type MessagesMessageSettingsRetrieveApiResponse,
  type MessagesMessageSettingsUpdateApiArg,
  type MessagesMessageSettingsUpdateApiResponse,
} from './operations.gen.ts';

export const addTagTypes = ['messages'] as const;

export const messageSettingsApi = coreApi
  .enhanceEndpoints({ addTagTypes })
  .injectEndpoints({
    endpoints: (build) => ({
      messagesMessageSettingsRetrieve: build.query<
        MessagesMessageSettingsRetrieveApiResponse,
        MessagesMessageSettingsRetrieveApiArg
      >({
        query: () => ({ url: `/messages/message-settings/` }),
        providesTags: ['messages'],
      }),
      messagesMessageSettingsUpdate: build.mutation<
        MessagesMessageSettingsUpdateApiResponse,
        MessagesMessageSettingsUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/messages/message-settings/`,
          method: 'PUT',
          body: queryArg.messageSettings,
        }),
        invalidatesTags: ['messages'],
      }),
    }),
    overrideExisting: false,
  });

export const {
  useMessagesMessageSettingsRetrieveQuery,
  useLazyMessagesMessageSettingsRetrieveQuery,
  useMessagesMessageSettingsUpdateMutation,
} = messageSettingsApi;
